import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { notification } from "antd";
import InputMask from "react-input-mask";
import BackIcon from "../../../images/icon-back.png";
import fetchSiteList from "../../../api/sites/fetchSiteList";

const Edit = () => {
  const url = process.env.REACT_APP_APP_BACK_URL;
  const react_base_url = process.env.REACT_APP_BASE_URL;
  const isAuthenticated = useSelector((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [error, setError] = useState(null);

  const [credentials, setCredentials] = useState({
    time: "",
    type: "",
  });
  const handleInput = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    (async () => {
      getData();
    })();
  }, []);

  const getData = async () => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("auth-token", localStorage.getItem("token"));
    // setIsLoading(true);
    const response = await fetch(`${url}/api/timeout/getById/${id}`, {
      mode: "cors",
      method: "get",
      headers: headers,
    });
    // setIsLoading(false);
    const json = await response.json();
    if (json.success) {
      let usr = json.data;
      setCredentials({
        time: usr.time,
        type: usr.type,
      });
    } else {
    }
  };

  const formSubmit = async (e) => {
    e.preventDefault();
    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      headers.append("auth-token", localStorage.getItem("token"));
      setIsLoading(true);
      const response = await fetch(`${url}/api/timeout/update/${id}`, {
        mode: "cors",
        method: "PUT",
        headers: headers,
        body: JSON.stringify({
          time: credentials.time,
          type: credentials.type,
        }),
      });
      setIsLoading(false);
      const json = await response.json();
      if (json.success) {
        notification.success({
          message: "Success",
          description: "Updated Successfully",
          duration: 3,
        });
      } else {
        notification.error({
          message: "Failed",
          description: json?.error,
          duration: 3,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const iocnStyle = {
    display: isLoading ? "inline-block" : "none",
  };

  return (
    <div className="general-dashboard">
      <div className="container-fluid">
        <div className="dashboard-top-row add-new-top-row">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <div className="user-wrap user-back-wrap">
                <Link to="/time-out/list">
                  <div className="back-icon">
                    <img src={BackIcon} alt="" />
                  </div>
                </Link>
                <div className="user-back-det">
                  <h3>Update TimeOut</h3>
                  <p>Enter the credentials to update timeouts in the system</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 text-end"></div>
          </div>
        </div>
        {/* row */}
        <form onSubmit={formSubmit}>
          <div className="form-box card-box">
            <div className="row">
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Time</h4>
                      <p>Enter the time of timeout</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="number"
                        className="form-control"
                        id="time"
                        placeholder="Time"
                        name="time"
                        value={credentials.time}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Type</h4>
                      <p>Select type of timeout</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <select
                        className="form-control"
                        id="type"
                        name="type"
                        value={credentials.type}
                        onChange={handleInput}
                        required
                        disabled
                      >
                        <option value="">Choose type</option>
                        <option value="Admin">Admin</option>
                        <option value="PickUps">PickUps</option>
                        {credentials.type &&
                          credentials.type !== "Admin" &&
                          credentials.type !== "PickUps" && (
                            <option value={credentials.type}>
                              {credentials.type}
                            </option>
                          )}
                      </select>
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>

              <div className="col-lg-12 text-end">
                <div className="form-btn-wrap mb-5 pb-5">
                  <button
                    type="submit"
                    disabled={isLoading}
                    href=""
                    className="btn btn-prim w-auto ms-5"
                  >
                    <i className="fa fa-spinner fa-spin" style={iocnStyle}></i>{" "}
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default Edit;
